import React from 'react'
import { TableCell, TableRow, Chip } from '@mui/material'
import dayjs from 'dayjs'
import { MembershipI } from 'src/api/membershipApi/types'
type DataRowProps = {
  membership: MembershipI
}
const DataRow = ({ membership }: DataRowProps) => {
  function getStatus() {
    if (membership.status === 'A') {
      // active
      return <Chip label='Active' color='success' />
    }
    if (membership.status === 'C') {
      // active
      return <Chip label='Canceled' color='warning' />
    }
    if (membership.status === 'I') {
      // active
      return <Chip label='Inactive' color='secondary' />
    }
    if (membership.status === 'E') {
      // active
      return <Chip label='Expired' color='error' />
    }
    return null
  }

  return (
    <TableRow hover tabIndex={-1}>
      <TableCell>
        {membership?.purchased_by?.first_name} {membership?.purchased_by?.last_name}
      </TableCell>
      <TableCell>{membership?.purchased_by?.trainer_category?.name}</TableCell>
      <TableCell>{membership?.plan?.plan_name}</TableCell>
      <TableCell>{membership?.plan?.total_price}</TableCell>
      <TableCell>{membership.transaction_id}</TableCell>
      <TableCell>{dayjs(membership.purchase_date).format('DD MMM YYYY, hh:mm a')}</TableCell>
      <TableCell>{dayjs(membership.expiry_date).format('DD MMM YYYY, hh:mm a')}</TableCell>
      <TableCell> {getStatus()} </TableCell>
    </TableRow>
  )
}

export default DataRow
